import React, { useCallback } from 'react';
import { Container, ToastConfirmacao } from './styles';

export const Confirmacao: React.FC = () => {
  const handleNextStep = useCallback(() => {
    window.location.href = `${process.env.REACT_APP_URL_PORTAL_HAVAN}`;
  }, []);

  return (
    <Container>
      <ToastConfirmacao>
        <p id="toast-title">Atenção</p>
        <p id="toast-info">Seu pagamento já foi recebido</p>
      </ToastConfirmacao>
    </Container>
  );
};
